import { type WithQuizId } from '../model'
import { type WithOptionalScheme, withScheme } from './util'

export const toTakeQuiz = ({ includeScheme = false, quizId }: WithOptionalScheme & WithQuizId): string => {
  return withScheme(`quiz/take/${quizId}`, includeScheme)
}
